<template>
      <v-dialog v-model="open" :max-width="tamModal" :scrollable="$root.isTouch == false" :fullscreen="$root.isTouch"
            persistent>
            <v-card elevation="11">
                  <v-card-title class="bg-title-card">
                        <span class="white--text headline" v-html="obModal.titulo"></span>
                  </v-card-title>
                  <v-card-text>
                        <v-form ref="form">
                              <v-container fluid grid-list-sm>
                                    <v-row dense>
                                          <v-col cols="12" sm="6">
                                                <v-text-field label="Nombre Usuario *" color="textbox"
                                                      v-model="obModal.usuario"
                                                      :rules="_.concat(requeridoRegla,emailRegla,max200Regla)"
                                                      outlined dense />
                                          </v-col>
                                          <v-col cols="12" sm="6">
                                                <v-text-field label="Nombres *" color="textbox"
                                                      v-model="obModal.nombres"
                                                      :rules="_.concat(requeridoRegla,letrasRegla,max200Regla)"
                                                      outlined dense />
                                          </v-col>
                                    </v-row>

                                    <v-row dense>
                                          <v-col cols="12" sm="6">
                                                <v-text-field label="Apellidos *" color="textbox"
                                                      v-model="obModal.apellidos"
                                                      :rules="_.concat(requeridoRegla,letrasRegla,max200Regla)"
                                                      outlined dense />
                                          </v-col>
                                          <v-col cols="12" sm="6">
                                                <v-autocomplete label="Perfil *" color="textbox"
                                                      :items="_.filter(listGeneral.listPerfil,(v)=>{ return !_.isNull(v.value); })"
                                                      :rules="requeridoRegla" v-model='obModal.idPerfil' outlined
                                                      dense @change="OnCheckPerfil" />
                                          </v-col>
                                    </v-row>

                                    <v-row dense>
                                          <v-col cols="12" :sm="!isCliente && !isAseguradora ? 6 : 4">
                                                <v-autocomplete label="Tipo Usuario *" color="textbox"
                                                      :items="_.filter(listGeneral.listTipoUsuario,(v)=>{ return (v.visualiza == 'true'); })"
                                                      item-text="tipoUsuario" item-value="idTipoUsuario"
                                                      :rules="requeridoRegla" v-model='obModal.idTipoUsuario' outlined
                                                      dense />
                                          </v-col>
                                          <v-col cols="12" sm="4" v-show="isCliente">
                                                <v-autocomplete label="Cliente *" color="textbox"
                                                      :items="_.filter(listGeneral.listCliente,(v)=>{ return !_.isNull(v.value); })"
                                                      :rules="isCliente ? requeridoRegla : []" v-model='obModal.idCliente' outlined
                                                      dense />
                                          </v-col>
                                          <v-col cols="12" sm="4" v-show="isAseguradora">
                                                <v-autocomplete label="Aseguradora *" color="textbox"
                                                      :items="_.filter(listGeneral.listAseguradora,(v)=>{ return !_.isNull(v.value); })"
                                                      :rules="isAseguradora ? requeridoRegla : []" v-model='obModal.idAseguradora' outlined
                                                      dense />
                                          </v-col>
                                          <v-col cols="12" :sm="!isCliente && !isAseguradora ? 6 : 4">
                                                <v-autocomplete label="Estado *" color="textbox"
                                                      :items="_.filter(listGeneral.listEstado,(v)=>{ return (v.visualiza == 'true'); })"
                                                      item-text="nombre_estado" item-value="id_estado"
                                                      :rules="requeridoRegla" v-model='obModal.idEstado' outlined
                                                      dense />
                                          </v-col>
                                    </v-row>

                                    <v-row dense>
                                          <v-col class="text-right">
                                                <v-btn outlined rounded color="danger" class="mr-1"
                                                      @click="clear(false)" :disabled="disabled">Cancelar</v-btn>
                                                <v-btn rounded dark color="primary" @click="validar" :disabled="disabled">Guardar</v-btn>
                                          </v-col>
                                    </v-row>
                              </v-container>
                        </v-form>
                  </v-card-text>
            </v-card>
      </v-dialog>
</template>

<script>
      export default {
            name: 'ModalUsuarioComponent',
            inject: ['close', 'submit'],
            props: {
                  open: {
                        type: Boolean,
                        default: false
                  },
                  obModal: {
                        type: Object,
                        default: {}
                  },
                  listGeneral: {
                        type: Object,
                        default: {}
                  },
                  parametros: {
                        type: Object,
                        default: {}
                  },
            },
            data: () => ({
                  disabled: false,
                  isCliente:false,
                  isAseguradora:false
            }),
            created() {
                  if (!_.isUndefined(this.$refs.form))
                        this.$refs.form.resetValidation()
                  this.OnCheckPerfil('L')
            },
            watch: {
                  open(val) {
                        if (!_.isUndefined(this.$refs.form))
                              this.$refs.form.resetValidation()
                        if(val)
                              this.OnCheckPerfil('L')
                  }
            },
            methods: {
                  clear() {
                        if (!_.isUndefined(this.$refs.form))
                              this.$refs.form.resetValidation();
                        this.disabled      =  false;
                        this.isCliente     = false;
                        this.isAseguradora = false;
                        this.close(false);
                  },
                  OnCheckPerfil(ev){
                        if(!_.isUndefined(ev)){
                              var idPerCli = _.toNumber(_.get(this.parametros,'id_perfil_cliente',-1));
                              var idPerAse = _.toNumber(_.get(this.parametros,'id_perfil_aseguradora',-2));
                              var idPerfil = _.toNumber(_.get(this.obModal,'idPerfil',0)); 
                              
                              switch (idPerfil) {
                                    case idPerCli:
                                          this.isCliente = true;
                                          this.isAseguradora = false;
                                          break;
                                    case idPerAse:
                                          this.isAseguradora = true;
                                          this.isCliente = false;
                                          break;
                                    default:
                                          this.isCliente = false;
                                          this.isAseguradora = false;
                                          break;
                              }
                        }
                  },
                  validar() {
                        try {
                              if (!this.$refs.form.validate()) throw mensajeEstandar.corregirInformacion;
                                    this.submit();
                        } catch (ex) {
                              mensajesAlerta(ex, 'I');
                              this.disabled = false;
                        }
                  }
            },
      }
</script>